// Packages and components
import React, { useState } from 'react';
import { Box, Button, Image } from 'grommet';
import { ShareRounded } from 'grommet-icons';
import FacebookButton from './FacebookButton';
import SHDButton from '@ui/Button/SHDButton';
import SHDCallout from '@ui/Callout/SHDCallout';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';
import Toast from '@components/Toast';
import YouTubeButton from './YoutubeButton';

// Helpers and utilities
import CopyToClipboard from 'react-copy-to-clipboard';
import { analytics } from '@services/analytics';

// Types and enums
import type { StreamingSelectionPageProps } from '../Onboarding.d';

const StreamingSelectionPage: React.FC<StreamingSelectionPageProps> = ({
  onContinue,
  teamId,
  isAdmin,
  teamName,
  modalHeight,
  sportType,
}) => {
  const [copied, setCopied] = useState(false);
  return (
    <Box height={modalHeight}>
      <SHDModalContainer>
        <Box gap="xsmall">
          <SHDHeading level="3">You&apos;re ready to go live!</SHDHeading>
          <SHDText color="gray-900-alpha-80" style="subhead">
            Tap Go live from team page on the streaming device and start scoring
            from another device.
          </SHDText>
        </Box>
      </SHDModalContainer>

      <SHDFooter>
        <SHDModalContainer>
          <Box gap="xsmall" margin={{ bottom: 'xxxlarge' }}>
            <SHDText style="body-semibold">Streaming to</SHDText>
            <SHDCallout round="medium">
              <CopyToClipboard
                text={`http://sidelinehd.com/live/${teamId}`}
                onCopy={() => {
                  setCopied(true),
                    analytics.track('Clicked Share', {
                      teamId: teamId,
                      sport: sportType,
                      context: '',
                      sharedTo: '',
                    });
                }}
              >
                <Button
                  onClick={() => {}}
                  disabled={false}
                  style={{ width: '100%' }}
                >
                  <Box
                    direction="row"
                    gap="medium"
                    align="center"
                    pad="xsmall"
                    round="medium"
                  >
                    <Box>
                      <Image
                        src={'/onboarding/shdLogo.png'}
                        fit="contain"
                        style={{ width: '48px', height: '48px' }}
                        alt="Custom Card Image"
                      />
                    </Box>
                    <Box flex>
                      <SHDText style="subhead-semibold">sidelineLive</SHDText>
                      <SHDText style="footnote" color="gray-500">
                        {`sidelinehd.com/${teamName.replace(/\s+/g, '')}/live`}
                      </SHDText>
                    </Box>
                    <Box flex={{ shrink: 0, grow: 0 }}>
                      <ShareRounded size="24px" color="black" />
                    </Box>
                  </Box>
                </Button>
              </CopyToClipboard>
            </SHDCallout>
            <YouTubeButton
              teamId={teamId}
              isAdmin={isAdmin}
              sportType={sportType}
            />
            <FacebookButton
              teamId={teamId}
              isAdmin={isAdmin}
              truncateLength={20}
              sportType={sportType}
            />
          </Box>
          <SHDButton primary label="Done" onClick={onContinue} />
        </SHDModalContainer>
      </SHDFooter>

      {copied ? (
        <Toast
          label="Copied url to clipboard!"
          background="status-ok"
          duration={3000}
          onClose={() => {
            setCopied(false);
          }}
        />
      ) : null}
    </Box>
  );
};

export default StreamingSelectionPage;
